import * as React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDoubleUp, faAngleDown, faAngleDoubleDown, faSquare, faPills, faSearchPlus } from '@fortawesome/free-solid-svg-icons'

library.add(faAngleUp, faAngleDoubleUp, faAngleDown, faAngleDoubleDown, faSquare, faPills, faSearchPlus);

const Icons = {
    changeDeleterious: <FontAwesomeIcon icon="square" className="ll-icon ll-deleterious" />,
    noChange: <FontAwesomeIcon icon="square" className="ll-icon ll-no-change" />,

    decreaseLarge: <FontAwesomeIcon icon="angle-double-down" className="ll-icon ll-decrease" />,
    decreaseModerate: <FontAwesomeIcon icon="angle-down" className="ll-icon ll-decrease" />,
    increaseLarge: <FontAwesomeIcon icon="angle-double-up" className="ll-icon ll-increase" />,
    increaseModerate: <FontAwesomeIcon icon="angle-up" className="ll-icon ll-increase" />,

    associatedDrug: <FontAwesomeIcon icon="pills" className="ll-icon ll-associated-drug" title="Associated drug" />,

    searchPlus: <FontAwesomeIcon icon="search-plus" className="ll-icon" />,
}

export default Icons;
